import type { ComponentType, SVGProps } from 'react';

// On-brand "invitation" empty state for screens whose final design hasn't landed
// yet. Dashed border, never a blank void (per the design system).
export function Placeholder({
  Icon,
  title,
  body
}: {
  Icon: ComponentType<SVGProps<SVGSVGElement>>;
  title: string;
  body: string;
}) {
  return (
    <div className="mt-4 flex flex-col items-center rounded-[28px] border border-dashed border-ink4 bg-wash px-6 py-14 text-center">
      <div className="grid h-14 w-14 place-items-center rounded-2xl bg-fill">
        <Icon width={26} height={26} strokeWidth={1.8} className="text-ink3" />
      </div>
      <div className="mt-4 text-[18px] font-extrabold tracking-tight text-ink">{title}</div>
      <p className="mt-2 max-w-[300px] text-[14px] font-medium leading-[1.45] text-ink2">{body}</p>
    </div>
  );
}
